<template>
    <div class="topic_list">
        <Header v-if="!isWx" :title="title" />
        <div class="listBox" :style="{'padding-top': isWx?'0':'60px'}">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="initInviteList"
            >
                <van-cell v-for="item in inviteList" :key="item.id">
                    <a @click="jumpPage(item.redirect_url)" class="item">
                        <div class="intro" :style="{'height': item.resources.length > 0 ? '5rem' : 'auto'}">
                            <p class="van-multi-ellipsis--l2">
                                {{ item.title }}
                            </p>
                            <span
                                >{{
                                    item.answer_num > 0
                                        ? item.answer_num + "回答"
                                        : "暂无回答"
                                }}&nbsp;{{
                                    item.loves > 0 ? item.loves + "点赞" : ""
                                }}</span
                            >
                        </div>
                        <van-image
                            v-if="item.resources[0]"
                            lazy-load
                            fit="cover"
                            :width="120"
                            :height="80"
                            :src="
                                item.resources[0]
                                    ? item.resources[0].cut_image
                                    : ''
                            "
                        />
                    </a>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>

<script>
import { Header } from '@/components'
import { getIndexList } from '@/request/api'
import { checkWx, navigate } from '@/pages/index/custom'

export default {
    components :{
        Header
    },
    data() {
        return {
            title: "",
            id: "",
            inviteList: [],
            loading: false, // 加载中
            finished: false, // 加载完毕
            invitePage: 1,
            isWx: true
        };
    },
    methods: {
        initInviteList() {
            getIndexList({
                page: this.invitePage,
                pcount: 8,
                type: 2,
                cid: this.id,
            }).then( res => {
                let {list, error_code} = res;
                if(error_code === 0) {
                    if (list.length === 0 || !list) {
                        this.finished = true;
                        return false;
                    }
                    list.map(item => {
                        if(!item.adv_data){
                            return this.inviteList.push(item)
                        }
                    });
                    this.invitePage++;
                    this.loading = false;
                }
            }).catch( error => {
                console.log(error)
            })
        },
        jumpPage(url) {
            navigate('', url+'&program=1')
        }
    },
    created() {
        this.isWx = checkWx()
        let {id, name} = this.$route.query;
        this.title = name.replace(/[&\|\\\*^%$#@\-]/g,"");
        this.id = id;
        // this.initInviteList();
    }
};
</script>

<style lang="less" scoped>
.listBox {
    box-sizing: border-box;
    .item {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding: 1.25rem;
        .intro {
            flex: 1;
            padding-right: 1rem;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            p {
                font-size:18px;
                font-weight:500;
                color:rgba(34,34,34,1);
            }
            span {
                display: block;
                font-size:12px;
                font-weight:400;
                color:rgba(167,167,167,1);
                margin-top: .625rem;
            }
        }
        .van-image {
            border-radius: 4px;
            overflow: hidden;
        }
    }
}
.head {
    position: fixed;
    width: 100%;
    height: 3.75rem;
    top: 0;
    left: 0;
    background-color: #fff;
    z-index: 4000;
    .goBack {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 1.25rem;
        width: 1.5rem;
        height: 1.5rem;
        background: url(../../../../../assets/img/icon_back.png);
        background-size: 100% 100%;
    }
}
.tab {  
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    height: 3.75rem;
    line-height: 3.75rem;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    div {
        position: relative;
        margin: 0 .75rem;
        font-size:16px;
        font-weight:400;
        color:rgba(34,34,34,1);
        height: 100%;
        line-height: 3.75rem;
        transition: all .3s;
        list-style: none;
        &.active{
            font-size:24px;
            font-weight:600;
        }
    }
    .line {
        position: absolute;
        bottom: 8px;
        left: 50%;
        margin-left: -10px;
        width: 1.25rem;
        height: .25rem;
        background-color: #FF4C67;
        box-shadow: 0px 2px 6px 0px #fd7c90;
        border-radius: 10px;
    }
}
</style>
